import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const SearchFormField = ({ input, label, type, name, clang, meta: { touched, error } }) => {
	return (
		<div className="search-bar__form-field" title={ lang[ clang ].title.search_bar }>
			<div className="search-bar__form-label" aria-label={ lang[ clang ].aria.search_bar }>
				{/* {label} */ }
				<input name={ name } { ...input } type={ type } placeholder={ label } className="search-bar__form-input" title={ lang[ clang ].search.what } />
			</div>
			{/* {touched && (error &&
                <div className="search-bar__form-error">{lang[clang].validation[error]}</div>)} */}
		</div>
	);
};

SearchFormField.propTypes = {
	clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SearchFormField);



// WEBPACK FOOTER //
// ./src/components/search/SearchFormField.js